import React from 'react';
import { FadeIn, SectionDivider } from '../ui';
import { AlertTriangle, Eye, Flame } from 'lucide-react';
export const ProblemSections = () => {
  return <div className="bg-mystic-900 relative" data-id="element-126">
      {/* BLOQUE 2: EL DOLOR */}
      <section className="py-20 px-4 relative overflow-hidden" data-id="element-127">
        <div className="absolute top-0 right-0 w-full md:w-1/2 h-full opacity-10 pointer-events-none" data-id="element-128">
          <img src="https://cdn.magicpatterns.com/uploads/mLt6zmWg4iG7hGKFnK4MFL/bloque_del_dolor.png" alt="Libro ancestral" className="w-full h-full object-cover object-left mask-image-linear-left" style={{
          WebkitMaskImage: 'linear-gradient(to left, black, transparent)'
        }} data-id="element-129" />
        </div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-130">
          <FadeIn data-id="element-131">
            <div className="relative mb-12 rounded-2xl overflow-hidden border border-gold/15 shadow-[0_20px_60px_rgba(0,0,0,0.6)]" data-id="element-132">
              <img src="https://cdn.magicpatterns.com/uploads/41gTqu3yHnDdMHNXaXR1hz/ChatGPT_Image_22_may_2026,_09_25_37_p.m..png" alt="Mujer sola en la noche revisando su teléfono" className="w-full h-auto object-cover" data-id="element-133" />
              <div className="absolute inset-0 bg-gradient-to-t from-mystic-900 via-mystic-900/30 to-transparent pointer-events-none" data-id="element-134"></div>
              <div className="absolute inset-0 bg-gradient-to-r from-mystic-900/40 via-transparent to-mystic-900/40 pointer-events-none" data-id="element-135"></div>
            </div>
          </FadeIn>
          <FadeIn data-id="element-136">
            <div className="space-y-6 text-lg md:text-xl text-text-secondary leading-relaxed font-serif italic" data-id="element-137">
              <p data-id="element-138">
                ¿Cuántas veces has revisado su WhatsApp sabiendo que no hay nada
                nuevo?
              </p>
              <p data-id="element-139">
                ¿Cuántas noches te dormiste con el teléfono en la mano esperando
                un mensaje que no llegó?
              </p>
              <p data-id="element-140">Ese vacío en el pecho que no desaparece con nada.</p>
              <p data-id="element-141">Esa sensación de que algo fue roto injustamente.</p>
              <p data-id="element-142">
                De que si tan solo pudieran hablar cinco minutos, todo volvería
                a su lugar.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} className="mt-12 space-y-6 text-text-primary" data-id="element-143">
            <p data-id="element-144">En medio de ese dolor buscaste ayuda.</p>
            <p data-id="element-145">
              Quizás fue un "Maestro" en Facebook. Una "Vidente" en TikTok con
              miles de seguidores y fotos de testimonios que parecían reales. Te
              prometieron resultados en 72 horas.
            </p>
            <p data-id="element-146">
              Te pidieron dinero para "materiales especiales", "limpiezas de
              energía", "refuerzos".
            </p>
            <p className="font-bold text-xl mt-8" data-id="element-147">¿El resultado? Cero.</p>
            <p data-id="element-148">
              O peor: te dijeron que la energía negativa era "más fuerte de lo
              esperado" y que necesitabas pagar más para terminar el trabajo.
            </p>

            <div className="mt-10 p-6 border-l-2 border-burgundy bg-burgundy/5" data-id="element-149">
              <p className="text-2xl font-serif text-white" data-id="element-150">
                Eso no fue un ritual.
              </p>
              <p className="text-2xl font-serif text-burgundy font-bold mt-2" data-id="element-151">
                Eso fue un robo.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      <SectionDivider data-id="element-152" />

      {/* BLOQUE 3: EL VILLANO */}
      <section className="py-12 px-4" data-id="element-153">
        <div className="max-w-3xl mx-auto" data-id="element-154">
          <FadeIn data-id="element-155">
            <div className="flex items-center gap-3 mb-8" data-id="element-156">
              <Eye className="text-gold" size={28} data-id="element-157" />
              <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-158">
                La verdad incómoda que nadie te dice
              </h2>
            </div>

            <div className="space-y-6 text-lg text-text-secondary" data-id="element-159">
              <p data-id="element-160">
                Quiero que entiendas algo que nadie te ha dicho con honestidad:
              </p>
              <p className="text-xl text-gold font-serif" data-id="element-161">
                Los brujos modernos necesitan que sigas sufriendo.
              </p>
              <p data-id="element-162">
                Su negocio no es devolverte a tu pareja.
                <br data-id="element-163" />
                Su negocio es tu desesperación.
              </p>
              <p data-id="element-164">
                Mientras más desesperado/a estés, más pagas. Y ellos lo saben
                perfectamente.
              </p>

              <ul className="space-y-4 mt-8 glass-panel p-8 rounded-xl" data-id="element-165">
                <li className="flex gap-3" data-id="element-166">
                  <span className="text-burgundy mt-1" data-id="element-167">✗</span>
                  <span data-id="element-168">
                    Por eso inventan el "trabajo con materiales especiales de
                    $300".
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-169">
                  <span className="text-burgundy mt-1" data-id="element-170">✗</span>
                  <span data-id="element-171">
                    Por eso te dicen que hay "entidades oscuras bloqueando tu
                    amor" que solo ellos pueden limpiar.
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-172">
                  <span className="text-burgundy mt-1" data-id="element-173">✗</span>
                  <span data-id="element-174">
                    Por eso el amarre "casi funcionó pero necesita un refuerzo".
                  </span>
                </li>
              </ul>

              <p className="mt-8" data-id="element-175">
                Es un ciclo diseñado para vaciarte el bolsillo mientras el
                tiempo pasa.
              </p>
              <p data-id="element-176">
                Y mientras tú esperas ese milagro que nunca llega porque pagaste
                a un extraño para que hiciera lo que solo tú puedes hacer, la
                persona que amas sigue su vida.
              </p>

              <p className="text-2xl font-bold text-white mt-8" data-id="element-177">
                Hoy eso se termina.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      <SectionDivider data-id="element-178" />

      {/* BLOQUE 4: PARA QUIÉN ES ESTO */}
      <section className="py-12 px-4 relative" data-id="element-179">
        <div className="absolute inset-0 bg-radial-glow opacity-30 pointer-events-none" data-id="element-180"></div>
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-181">
          <FadeIn data-id="element-182">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-183">
              Esto es para ti si...
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-184">
              {['Tu pareja se alejó de repente sin una razón clara, como si algo hubiera cambiado en él/ella de un día para otro.', 'Sospechas que una tercera persona, los celos de alguien cercano o una envidia externa interfirieron en tu relación.', 'Ya le pagaste a un "maestro" o "vidente" y no obtuviste ningún resultado real — solo más gastos.', 'Tu ex te bloqueó, dejó de responder o desapareció dejándote sin ningún cierre.', 'Sientes que la conexión entre ustedes todavía existe, pero algo o alguien la está bloqueando.'].map((text, idx) => <div key={idx} className="glass-panel p-6 rounded-xl flex gap-4 items-start hover:border-gold/40 transition-colors" data-id="element-185">
                  <div className="text-gold mt-1" data-id="element-186">
                    <Flame size={20} data-id="element-187" />
                  </div>
                  <p className="text-text-primary" data-id="element-188">{text}</p>
                </div>)}
            </div>

            <div className="mt-12 text-center" data-id="element-189">
              <p className="text-xl text-gold font-serif italic" data-id="element-190">
                Si te identificas con al menos una de estas situaciones,
                <br data-id="element-191" />
                lo que vas a leer a continuación puede cambiar todo.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      <SectionDivider data-id="element-192" />

      {/* BLOQUE 5: EL GIRO */}
      <section className="py-12 px-4" data-id="element-193">
        <div className="max-w-3xl mx-auto text-center" data-id="element-194">
          <FadeIn data-id="element-195">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-196">
              Por qué tú eres el único que puede traerlo/a de regreso
            </h2>

            <div className="space-y-6 text-lg text-text-secondary text-left" data-id="element-197">
              <p data-id="element-198">
                Aquí está lo que los falsos maestros te ocultan deliberadamente:
              </p>
              <p className="text-xl text-white font-medium" data-id="element-199">
                La energía que te une a esa persona no puede ser manipulada por
                un extraño.
              </p>
              <p data-id="element-200">
                Los maestros originales — los que desarrollaron estas prácticas
                siglos antes de que existieran los "brujos de Instagram" —
                sabían algo fundamental:
              </p>

              <div className="py-8 my-8 border-y border-gold/20 text-center" data-id="element-201">
                <p className="text-2xl md:text-3xl font-serif text-gold italic" data-id="element-202">
                  El hilo que une dos almas solo puede ser jalado
                  <br data-id="element-203" />
                  por alguien que forma parte de ese hilo.
                </p>
                <p className="text-xl font-bold text-white mt-4 uppercase tracking-widest" data-id="element-204">
                  Ese alguien eres TÚ.
                </p>
              </div>

              <p data-id="element-205">
                Cuando un extraño intenta hacer un amarre por ti, el universo lo
                detecta como un intruso. Una persona sin ningún cordón
                energético con tu ser amado, haciendo movimientos vacíos en una
                habitación oscura.
              </p>
              <p data-id="element-206">
                Por eso siempre fallan. Por eso siempre piden más dinero para el
                "refuerzo".
              </p>

              <div className="mt-10 bg-mystic-800 p-8 rounded-xl text-center border border-gold/10" data-id="element-207">
                <p className="text-lg" data-id="element-208">
                  El ritual que vas a tener en tus manos nació de un linaje que
                  entendía que el amor no se mendiga.
                </p>
                <p className="text-3xl font-serif font-bold text-gold mt-4" data-id="element-209">
                  Se reclama.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>
    </div>;
};